export const navigateTo = url => {
  if (typeof jasmine === 'undefined') {
    const targetUrl = decodeURI(url);
    window.location.assign(targetUrl);
  }
};